import React from "react";
import { CheckCircle2, XCircle, Clock } from "lucide-react";

const gold = "from-[#B17E32] via-[#F3E681] to-[#CF9F41]";

export default function AttendanceBadge({ status = "not_marked", counts }) {
  const cfg = {
    present:   { label: "Present", Icon: CheckCircle2, cls: `bg-gradient-to-r ${gold} text-black` },
    absent:    { label: "Absent",  Icon: XCircle,      cls: "bg-red-600/20 text-red-400 border border-red-600/40" },
    not_marked:{ label: "Not marked", Icon: Clock,     cls: "bg-neutral-800/60 text-neutral-400 border border-neutral-700" },
  }[status] || { label: "Not marked", Icon: Clock, cls: "bg-neutral-800/60 text-neutral-400 border border-neutral-700" };

  const { label, Icon, cls } = cfg;
  const right = counts?.total ? `${counts.present}/${counts.total}` : null;

  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold ${cls}`}>
      <Icon className="h-4 w-4" />
      {right ? `${label} · ${right}` : label}
    </span>
  );
}
